export default {
  methods: {
    validateCpf: function(cpf) {
      const cpfReplaced = cpf.replace(/\D/g,"");
      const characteres = cpfReplaced.split("");
      const cpfNoDigits = characteres.slice(0, 9);
      const cpfNoLastDigit = characteres.slice(0, 10);
      const verifierDigits = {
        first: {
          value: characteres[characteres.length - 2],
          ok: false,
          factor: 10,
          calculation: 0
        },
        second: {
          value: characteres[characteres.length - 1],
          ok: false,
          factor: 11,
          calculation: 0
        }
      };
      let identicalCharacteres = 0;

      //Conta se o caractere é igual ao atual
      for (let i = 0, len = characteres.length; i <= len; i++) {
        if (characteres[i] === characteres[i + 1]) {
          ++identicalCharacteres;
        }
      }

      //Verifica o primeiro dígito é válido
      for (let i = 0, len = cpfNoDigits.length; i < len; i++) {
        let numChar = parseInt(cpfNoDigits[i]);
        verifierDigits.first.calculation +=
          numChar * verifierDigits.first.factor;
        --verifierDigits.first.factor;
      }
      verifierDigits.first.calculation =
        (verifierDigits.first.calculation * 10) % 11;
      if (verifierDigits.first.calculation === 10) {
        verifierDigits.first.calculation = 0;
      }
      if (
        verifierDigits.first.calculation ===
        parseInt(verifierDigits.first.value)
      ) {
        verifierDigits.first.ok = true;
      }

      // Verifica se o segundo dígito é válido
      for (let i = 0, len = cpfNoLastDigit.length; i < len; i++) {
        let numChar = parseInt(cpfNoLastDigit[i]);
        verifierDigits.second.calculation +=
          numChar * verifierDigits.second.factor;
        --verifierDigits.second.factor;
      }
      verifierDigits.second.calculation =
        (verifierDigits.second.calculation * 10) % 11;
      if (verifierDigits.second.calculation === 10) {
        verifierDigits.second.calculation = 0;
      }
      if (
        verifierDigits.second.calculation ===
        parseInt(verifierDigits.second.value)
      ) {
        verifierDigits.second.ok = true;
      }

      if (
        characteres.length === 11 &&
        identicalCharacteres < 11 &&
        verifierDigits.first.ok &&
        verifierDigits.second.ok
      ) {
        return true;
      } else {
        return false;
      }
    },
    cpfLeftZeros: function(cpf) {
      const characteres = cpf.split("");
      const cpfLenght = characteres.length;
      if (cpfLenght < 11) {
        for (let i = 0; i < 11 - cpfLenght; i++) {
          characteres.unshift("0");
        }
      }
      return characteres.join("");
    },
    cpfMask: function(cpf) {
      const cpfReplaced = cpf.replace(/\D/g,"");
      const characteres = cpfReplaced.split("");
      characteres.splice(3, 0, ".");
      characteres.splice(7, 0, ".");
      characteres.splice(11, 0, "-");
      return characteres.join("");
    },
  }
}